<template>
  <div class="container-fixed">
    <h1>Description list test</h1>

    <section data-test="dl1">
      <h2>Without label and with manual content</h2>
      <VSection>
        <VDescriptionList>
          <dt>Key</dt>
          <dd>Value</dd>
        </VDescriptionList>
      </VSection>
    </section>

    <section data-test="dl2">
      <h2>With label</h2>
      <VSection label="my label" class="my_class">
        <VDescriptionList class="my_sub_class">
          <dt
            >This is a very long key which will be displayed in at least two lines lorem ipsum dolor lorem ipsum dolor lorem ipsum dolor lorem ipsum dolor lorem
            ipsum dolor lorem ipsum dolor</dt
          >
          <dd>Value</dd>
          <dt>And another one</dt>
          <dd
            >This is a very long value which will be displayed in at least two lines, lorem ipsum dolor lorem ipsum dolor lorem ipsum dolor lorem ipsum dolor
            lorem ipsum dolor lorem ipsum dolor</dd
          >
          <dt>Key</dt>
          <dd>Value</dd>
          <dt>extremelyLongTextHeaderSoThatWillBreakIfThereIsNotEnoughSpaceForTheWholeLineInThisHTMLElementOfChoiceAddingWhateverYouWantHere</dt>
          <dd
            >ThisIsTheValueOfThisExtremelyLongTextHeaderSoThatWillBreakIfThereIsNotEnoughSpaceForTheWholeLineInThisHTMLElementOfChoiceAddingWhateverYouWantHere</dd
          >
        </VDescriptionList>
      </VSection>
    </section>

    <section data-test="dl3">
      <h2>With i18n label (with html)</h2>
      <VSection label="common.test_html">
        <VDescriptionList>
          <dt>Key</dt>
          <dd>Value</dd>
        </VDescriptionList>
      </VSection>
    </section>

    <section data-test="dl4">
      <h2>With slot label</h2>
      <VSection>
        <template #label> My <b>HTML</b>-Label </template>
        <template #default>
          <VDescriptionList>
            <dt>Key</dt>
            <dd>Value</dd>
          </VDescriptionList>
        </template>
      </VSection>
    </section>

    <section data-test="dl5">
      <h2>Entries</h2>
      <VDescriptionList>
        <dt>Key</dt>
        <dd>Value</dd>
        <VEntry name="name1" value="value1" />
        <VEntry name="common.test_html" value="my value (with i18n name)" />
        <VEntry name="test <b>with HTML</b>-support" value="my value (with html name)" />
        <VEntry name="name (empty)" mandatory />
        <VEntry name="name (SHOULD NOT BE VISIBLE)" />
        <VEntry name="name (SHOULD NOT BE VISIBLE)" :data="{}" field="test" />
        <VEntry name="name (field)" :data="{ test: 'field test' }" field="test" />
        <VEntry name="name (field2)" :data="{ test: 'field test (with mandatory)' }" field="test" mandatory />
        <VEntry name="name (value is null)" :data="{ test: null }" field="test" mandatory />
        <VEntry name="name (value is null and optional) (SHOULD NOT BE VISIBLE)" :data="{ test: null }" field="test" />
        <VEntry name="name (value is empty and optional)" :data="{ test: '' }" field="test" />
        <VEntry name="name (with default)" :data="{}" field="test" default="my default value" />
        <VEntry name="name (with slot)">
          value via slot
        </VEntry>
        <VEntry name="name2 (with slot)" mandatory>
          value via slot (mandatory)
        </VEntry>
        <VEntry v-slot="{ value }" name="name (with slot scope)" value="my value">value via slot scope: {{ value }} </VEntry>
        <VEntry v-slot="{ value }" name="HTML value example" :data="{ foo: 'bar <b>with html</b>' }" field="foo"><span v-html="value"/></VEntry>
      </VDescriptionList>
    </section>

    <section data-test="dl6">
      <h2>Only optionals (with mandatory on root)</h2>
      <VSection label="my label" mandatory>
        <VDescriptionList>
          <VEntry name="my name (SHOULD NOT BE VISIBLE)" />
          <VEntry name="my name (SHOULD NOT BE VISIBLE)" :data="{}" field="test" />
        </VDescriptionList>
      </VSection>
    </section>

    <section data-test="dl7">
      <h2>Only optionals</h2>
      <VSection label="my label">
        <VDescriptionList>
          <VEntry name="my name (SHOULD NOT BE VISIBLE)" />
          <VEntry name="my name (SHOULD NOT BE VISIBLE)" :data="{}" field="test" />
        </VDescriptionList>
      </VSection>
    </section>

    <section data-test="dl8">
      <h2>Override key and value</h2>
      <VDescriptionList>
        <VEntry name="my name" value="my value with <u>HTML</u> content">
          <template #override="{ value }">
            <b>MY OVERRIDE VALUE: <span v-html="value"/></b>
            <dt>custom dt</dt>
            <dd>custom dd</dd>
          </template>
        </VEntry>
      </VDescriptionList>
    </section>

    <section data-test="dl9">
      <h2>Override value</h2>
      <VDescriptionList>
        <VEntry name="my name" value="my value with <u>HTML</u> content">
          <template #value="{ value }">
            <b>MY OVERRIDE VALUE: <span v-html="value"/></b>
          </template>
        </VEntry>
      </VDescriptionList>
    </section>

    <section data-test="dl10">
      <h2>Optional by slot has content</h2>
      <VDescriptionList>
        <VEntry name="my name">
          hello
        </VEntry>
      </VDescriptionList>
    </section>

    <section data-test="dl11">
      <h2>Optional with null field should never call slot (and never call label)</h2>
      <VSection>
        <template #label>
          {{ throwException() }}
        </template>
        <template #default>
          <VDescriptionList>
            <VEntry v-slot="{ value }" name="THIS SHOULD NOT BE VISIBLE" :data="null" field="doesNotExist">
              {{ throwException(value) }}
            </VEntry>
          </VDescriptionList>
        </template>
      </VSection>
    </section>

    <section data-test="dl12">
      <h2>Nested field</h2>
      <VDescriptionList>
        <VEntry name="my name" :data="{ foo: { bar: [0, 1, { deep: 'xyz' }, 3] } }" field="foo.bar[2].deep" />
        <VEntry name="my name (SHOULD NOT BE VISIBLE)" :data="{ foo: { bar: [0, 1, { deep: 'xyz' }, 3] } }" field="foo.notFound[2].deep" />
        <VEntry name="my name with different separator" :data="{ foo: { bar: [0, 1, { deep: 'xyz2' }, 3] } }" field="foo/bar[2]/deep" separator="/" />
      </VDescriptionList>
    </section>

    <section data-test="dl13">
      <h2>Without field, but only data</h2>
      <VDescriptionList>
        <VEntry name="name (empty field)" :data="{ exists: true, foo: 'bar' }" field>
          slot value1
        </VEntry>
        <VEntry v-slot="{ data }" name="SHOULD NOT BE VISIBLE" :data="null" field>
          {{ throwException(data) }}
        </VEntry>
        <VEntry name="name (without field)" :data="{ exists: true, foo: 'bar' }">
          slot value2
        </VEntry>
        <VEntry v-slot="{ data }" name="name (without field but v-slot)" :data="null">slot value3 {{ data }}</VEntry>
        <VEntry v-slot="{ data }" name="name (with field but empty slot SHOULD NOT BE VISIBLE)" :data="{ exists: true, foo: 'bar' }" field>
          <template v-if="false">
            {{ throwException(data) }}
          </template>
        </VEntry>
        <VEntry
          v-slot="{ data }"
          name="name (with field but empty slot via optional translation with null fallback SHOULD NOT BE VISIBLE)"
          :data="{ exists: true, foo: 'bar' }"
          field
        >
          {{ $tf(data) }}
        </VEntry>
        <VEntry name="name (with field but empty slot SHOULD NOT BE VISIBLE)" :data="{ exists: true, foo: 'bar' }" field />
        <VEntry v-slot="{ data }" name="name (with empty slot but nested tag)" :data="{ exists: true, foo: 'bar' }" field><hr :data="data"/></VEntry>
        <VEntry v-slot="{ data }" name="name (with empty slot but nested component)" :data="{ exists: true, foo: 'bar' }" field><VEmpty :data="data"/></VEntry>
      </VDescriptionList>
    </section>

    <section data-test="dl14">
      <h2>Boolean</h2>
      <VDescriptionList>
        <VEntry name="name (boolean true)" :data="{ flag: true }" field="flag" boolean />
        <VEntry name="name (boolean false)" :data="{ flag: false }" field="flag" boolean />
        <VEntry name="name (string)" :data="{ flag: 'any string' }" field="flag" boolean />
        <VEntry name="name (null) SHOULD NOT BE VISIBLE" :data="{ flag: null }" field="flag" boolean />
        <VEntry name="name (null mandatory)" :data="{ flag: null }" field="flag" boolean mandatory />
        <VEntry name="name (empty string)" :data="{ flag: '' }" field="flag" boolean />
        <VEntry name="name with OFFSET (positive)" :data="{ flag: true }" field="flag" boolean true="positive" false="negative" />
        <VEntry name="name (negative)" :data="{ flag: false }" field="flag" boolean true="positive" false="negative" />
        <VEntry name="name (i18n)" :data="{ flag: true }" field="flag" boolean true="common.test_html" />
      </VDescriptionList>
    </section>

    <section data-test="dl15">
      <h2>Groups</h2>
      <VDescriptionList>
        <VGroup label="my sub-headline">
          <VEntry name="sub-name" value="sub-value" />
          <VEntry name="my name" value="my value" />
        </VGroup>
        <VEntry name="my name" value="my value" />
        <VGroup label="my sub-headline2">
          <VEntry name="my name" value="my value" />
        </VGroup>
        <VGroup label="my sub-headline with default scoped slot">
          <template #default>
            <VEntry name="my name inside default scoped slot" value="my value" />
          </template>
        </VGroup>
        <VGroup label="my name (SHOULD NOT BE VISIBLE)">
          <VEntry name="my name (SHOULD NOT BE VISIBLE)" />
        </VGroup>
        <VGroup label="my name (mandatory)" mandatory>
          <VEntry name="my name (SHOULD NOT BE VISIBLE)" />
        </VGroup>
      </VDescriptionList>
    </section>

    <section data-test="dl16">
      <h2>Name by slot</h2>
      <VDescriptionList>
        <VEntry name="(SHOULD NOT BE VISIBLE)">
          <template #name>
            name1<!-- no space!
          --></template>
          <template #default>
            value1
          </template>
        </VEntry>
        <VEntry name="(SHOULD NOT BE VISIBLE)" value="value2">
          <template #name> name2<!-- no space! works also if comment is last entry --> </template>
        </VEntry>
        <VEntry :data="{ test: 'field test' }" field="test">
          <template #name>
            name3<!-- if you leave space here (or no comment), there will be a space between the name and the colon (':') - see name4 -->
          </template>
        </VEntry>
        <VEntry :data="{}" field="test">
          <template #name>
            (SHOULD NOT BE VISIBLE)
          </template>
        </VEntry>
        <VEntry :data="{}" field="test" mandatory>
          <template #name>
            name4
          </template>
        </VEntry>
        <VEntry :data="{ test: 'field test', other: { type: 'usethisname' } }" field="test" name-field="other.type">
          <template #name="{ value, name }"> name for {{ value }} is {{ name }}</template>
        </VEntry>
        <VEntry :data="{ test: 'field test', other: { type: 'usethisname' } }" field="test" name-field="other.invalid.xyz">
          <template #name="{ name }">non-existing name is {{ name === null ? 'NULL' : '(SHOULD NOT BE VISIBLE)' }}</template>
        </VEntry>
      </VDescriptionList>
    </section>

    <section data-test="dl17">
      <h2>Inside DetailBox</h2>

      <VDetailBoxWrapper>
        <VDetailBox>
          <template #headline>
            Headline
          </template>
          <template #default>
            <VDescriptionList>
              <VEntry name="my name" value="my value" />
              <VEntryBadge name="my name" badge="my badge" />
              <VEntryBadge name="my name" badge="my <i>html</i>-badge" class="badge-negative" />
              <VEntry value="my value">
                <template #name>
                  My label
                </template>
              </VEntry>
              <VEntry value="my value">
                <template #name>
                  <!-- button must come before text because of collon and mobile view! -->
                  <button class="btn btn-default btn-small pull-right">test</button>
                  label (with manual button)
                </template>
              </VEntry>
              <VEntryButton value="my value" label="button-label with <b>html</b>" :to="{ name: 'TEST' }" data-test="btn1">
                <template #name>
                  label (VEntryButton with props)
                </template>
              </VEntryButton>
              <VEntryButton value="my value" label="common.test_html" :to="{ name: 'TEST' }" data-test="btn2">
                <template #name>
                  label (VEntryButton with props with i18n)
                </template>
              </VEntryButton>
              <VEntryButton name="label via prop with :to" value="my value" label="Home" :to="{ name: 'TEST' }" data-test="btn3" />
              <VEntryButton name="label" value="my value" label="Focus me" data-test="btn4" @focus="cnt++" />
              <VEntryButton name="label via prop <b>With HTML</b>" value="my value" label="common.test_html" :to="{ name: 'TEST' }" data-test="btn5" />
              <VEntryButton name="label with click handler" :value="'cnt: ' + cnt" label="increment" data-test="btn6" @click="cnt++" />
              <VEntryButton name="label with click handler (and default slot)" label="increment" data-test="btn7" @click="cnt++"> cnt: {{ cnt }} </VEntryButton>
              <VEntryButton value="my value">
                <template #button>
                  <button class="btn btn-default btn-small pull-right" data-test="btn8">test</button>
                </template>
                <template #name>
                  label (VEntryButton with slot)
                </template>
              </VEntryButton>
              <VEntryButton name="label with additional class" value="my value" label="label" class="btn-brand" data-test="btn9" />
              <VEntryButton name="label with button hidden" value="my value" label="(SHOULD NOT BE VISIBLE)" hidden data-test="btn10" />
              <VEntryButton name="label with slot" data-test="btn11">
                <template #label>
                  label via slot
                </template>
              </VEntryButton>
              <VEntryButton name="label with empty label" value="my value" data-test="btn12" />
            </VDescriptionList>
          </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (with VEmpty)
          </template>
          <template #default>
            <VEmpty />
          </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (SHOULD NOT BE VISIBLE)
          </template>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (SHOULD NOT BE VISIBLE)
          </template>
          <template #default>
            <VDescriptionList>
              <VEntry name="my name (SHOULD NOT BE VISIBLE)" />
            </VDescriptionList>
          </template>
        </VDetailBox>

        <VDetailBox>
          <VDescriptionList>
            <VEntry name="my name (SHOULD NOT BE VISIBLE)" />
          </VDescriptionList>
        </VDetailBox>

        <VDetailBox>
          <template #headline>
            Headline (SHOULD NOT BE VISIBLE)
          </template>
          <template #default>
            <VDescriptionList>
              <VEntry name="my name (SHOULD NOT BE VISIBLE)">
                <template #name>
                  name (SHOULD NOT BE VISIBLE)
                </template>
                <template #default>
                  <template v-if="false">
                    not visible
                  </template>
                </template>
              </VEntry>
            </VDescriptionList>
          </template>
        </VDetailBox>

        <VDetailBox mandatory>
          <template #headline>
            Headline (mandatory)
          </template>
        </VDetailBox>
      </VDetailBoxWrapper>
    </section>

    <section data-test="dl18">
      <h2>EntryDate</h2>
      <VDescriptionList>
        <VEntryDate name="name (mandatory)" :data="{}" field="test" mandatory />
        <VEntryDate name="name (default)" :data="{ now: '2018-03-28T12:50:59+0000' }" field="now" />
        <VEntryDate name="name (with timezone offset)" :data="{ now: '2018-03-28T12:50:59+0200' }" field="now" />
        <VEntryDate name="name (without timezone)" :data="{ now: '2018-03-28T12:50:59' }" field="now" />
        <VEntryDate name="name (with space)" :data="{ now: '2018-03-28 12:50:59' }" field="now" />
        <VEntryDate name="name (wrong format)" :data="{ now: '18-03-28 12:50:59' }" field="now" />
        <VEntryDate name="name (wrong format2)" :data="{ now: 'abc' }" field="now" />
        <VEntryDate date name="name (date)" :data="{ now: '2018-03-28T12:50:59+0000' }" field="now" />
        <VEntryDate date-time name="name (date-time)" :data="{ now: '2018-03-28T12:50:59+0000' }" field="now" />
        <VEntryDate name="name (with value)" value="2018-03-28T12:50:59+0000" />
        <VEntryDate name="name with empty value (SHOULD NOT BE VISIBLE)" value="" />
        <VEntryDate name="name (with default slot - will be overritten)" :data="{ now: '2018-03-28T12:50:59+0000' }" field="now">
          (SHOULD NOT BE VISIBLE)
        </VEntryDate>
        <VEntryDate name="(SHOULD NOT BE VISIBLE)" :data="{ now: '2018-03-28T12:50:59+0000' }" field="now">
          <template #name>
            name (with name slot)
          </template>
        </VEntryDate>
        <VEntryDate name="name (unformatted date)" :data="{ now: '2018-03-28T12:50:59+0000' }" field="now" unformatted />
        <VEntryDate name="name (unformatted invalid)" :data="{ now: 'invalid format' }" field="now" unformatted />
        <VEntryDate name="name (auto)" :data="{ now: '2018-03-28' }" field="now" />
      </VDescriptionList>
    </section>

    <section data-test="dl19">
      <h2>EntryNumber + Divided</h2>
      <VDescriptionListDivided>
        <VEntryNumber name="name (default)" :data="{ d: 123.456789 }" field="d" />
        <VEntryNumber name="name (with value)" value="123.456789" />
        <VEntryNumber name="name (with short fraction)" value="123.9" />
        <VEntryNumber name="name (with value as number)" :value="123.456789" />
        <VEntryNumber name="name (with divide)" value="123.456789" :divide="100" />
        <VEntryNumber name="name (currency with divide)" value="123.456789" currency="EUR" :divide="100" />
        <VEntryNumber name="name (with digits)" value="123.456789" :digits="6" />
        <VEntryNumber name="name (currency with digits)" value="123.456789" currency="EUR" :digits="6" />
        <VEntryNumber name="name with null value (SHOULD NOT BE VISIBLE)" :value="null" />
        <VEntryNumber name="name with empty value (SHOULD NOT BE VISIBLE)" value="" />
        <VEntryNumber name="name (with default slot - will be overritten)" :data="{ d: 0 }" field="d">
          (SHOULD NOT BE VISIBLE)
        </VEntryNumber>
        <VEntryNumber name="(SHOULD NOT BE VISIBLE)" :data="{ d: 9999 }" field="d">
          <template #name>
            name (with name slot)
          </template>
        </VEntryNumber>
        <VEntryNumber name="name (currency blank)" currency :data="{ d: 123.456789 }" field="d" />
        <VEntryNumber name="name (currency EUR)" currency="EUR" :data="{ d: 123.456789 }" field="d" />
        <VEntryNumber name="name (currency, long number)" currency="EUR" :value="9999" />
        <VEntryNumber name="name (currency, short number)" currency="EUR" :value="1" />
        <VEntryNumber name="name (currency, negative)" currency="EUR" :value="-123.4" />
        <VEntryNumber
          name="name (currency based on field)"
          currency-field="price.cur"
          :data="{ price: { gross: 123.456789, cur: 'EUR' } }"
          field="price.gross"
        />
        <VEntryNumber
          name="name (currency based on field not found)"
          currency-field="price.curNotFound"
          :data="{ price: { gross: 123.456789, cur: 'EUR' } }"
          field="price.gross"
        />
        <VEntryNumber
          name="name (currency based on field with separator)"
          currency-field="price/cur"
          separator="/"
          :data="{ price: { gross: 123.456789, cur: 'EUR' } }"
          field="price/gross"
        />
        <VEntryNumber name="name (with suffix)" value="123.456" suffix=" %" />
        <VEntryNumber name="name (currency with suffix)" currency="EUR" value="123.456" suffix=" (Monatlich)" />
        <VEntryNumber name="name (mandatory)" :data="{}" field="test" mandatory />
      </VDescriptionListDivided>
    </section>

    <section data-test="dl20">
      <h2>DividedHorizontal</h2>
      <VDescriptionListDividedHorizontal>
        <VEntry name="name1" value="value1" />
        <VEntry name="name2" value="" mandatory />
        <VEntry name="name3" value="value3" />
        <VEntry name="name4" value="value4" />
        <VEntry name="name5" value="" mandatory />
      </VDescriptionListDividedHorizontal>
    </section>

    <section data-test="dl21">
      <h2>DividedHorizontal with even elements / check breakpoint</h2>
      <VDescriptionListDividedHorizontal>
        <VEntry name="name1" value="value1" />
        <VEntry name="name2" value="" mandatory />
        <VEntry name="name3" value="value3" />
        <VEntry name="name4" value="value4" />
        <VEntry name="name5" value="" mandatory />
        <VEntry name="name6" value="value6" />
      </VDescriptionListDividedHorizontal>
    </section>
  </div>
</template>

<script>
import VSection from '@/components/Section';
import VDescriptionList from '@/components/DescriptionList';
import VDescriptionListDivided from '@/components/DescriptionList/Divided';
import VEntry from '@/components/DescriptionList/Entry';
import VEntryDate from '@/components/DescriptionList/EntryDate';
import VEntryNumber from '@/components/DescriptionList/EntryNumber';
import VGroup from '@/components/DescriptionList/Group';
import VEmpty from '@/components/Empty';
import VDetailBoxWrapper from '@/components/UI/DetailBox/Wrapper';
import VDetailBox from '@/components/UI/DetailBox';
import VEntryButton from '@/components/DescriptionList/EntryButton';
import VEntryBadge from '@/components/DescriptionList/EntryBadge';
import VDescriptionListDividedHorizontal from '@/components/DescriptionList/DividedHorizontal';

export default {
  name: 'DescriptionListTest',

  components: {
    VSection,
    VDescriptionList,
    VDescriptionListDivided,
    VEntry,
    VEntryDate,
    VEntryNumber,
    VGroup,
    VEmpty,
    VDetailBoxWrapper,
    VDetailBox,
    VEntryButton,
    VEntryBadge,
    VDescriptionListDividedHorizontal,
  },

  data() {
    return {
      cnt: 0,
    };
  },

  methods: {
    throwException() {
      throw new Error('Should not be called!');
    },
  },
};
</script>

<style scoped>
section {
  padding: 12px;
  margin: 24px 0;
  background-color: #eeefef;
}

h2 {
  padding: 0 0 24px 0;
  margin: 0;
}

::v-deep .my_class h4::after {
  content: ' - with custom class!';
}

::v-deep .my_sub_class {
  color: red;
}
</style>
